import { render, staticRenderFns } from "./NameListProfile.vue?vue&type=template&id=695e541e&scoped=true&"
import script from "./NameListProfile.vue?vue&type=script&lang=js&"
export * from "./NameListProfile.vue?vue&type=script&lang=js&"
import style0 from "./NameListProfile.vue?vue&type=style&index=0&id=695e541e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e541e",
  null
  
)

export default component.exports